var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import TextInputCss from "./TextInputCss.js";
import "../Popup/Popup.js";
class TextInput extends s {
  constructor() {
    super();
    __publicField(this, "validate", () => {
      if (this.readonly) {
        return true;
      }
      const input = this.shadowRoot.querySelector("input");
      const valid = input.checkValidity();
      if (this.maxlength && this.value && this.value.length > this.maxlength) {
        this.classList.add("error");
        this.message = translateText(this._translations(), "length", this.maxlength);
      } else if (valid) {
        this.classList.remove("error");
        this.message = "";
      } else if (this.required && isEmpty(this.value)) {
        this.classList.add("error");
        this.message = translateText(this._translations(), "empty");
      } else {
        this.classList.add("error");
        this.message = this.patternErrorText;
      }
      this.requestUpdate();
      return valid;
    });
    __publicField(this, "getValue", () => this.value);
    __publicField(this, "hasChanges", () => this.valueChanged);
    this.message = "";
    this.valueChanged = false;
  }
  static get styles() {
    return [TextInputCss];
  }
  static get properties() {
    return {
      label: { type: String },
      helpText: { attribute: "help-text", type: String | Function },
      type: { type: String },
      value: { type: String },
      placeholder: { type: String },
      placeholderEmpty: { attribute: "placeholder-empty", type: String },
      pattern: { type: String },
      patternErrorText: { attribute: "pattern-error-text", type: String },
      maxlength: { type: Number },
      inline: { type: Boolean },
      disabled: { type: Boolean },
      required: { type: Boolean },
      readonly: { type: Boolean },
      title: { type: String }
    };
  }
  updated(changedProperties) {
    const updatedProperties = changedProperties.has("maxlength") || changedProperties.has("pattern") || changedProperties.has("required") || changedProperties.has("value");
    const shouldCheck = this.valueChanged || !!this.value;
    if (shouldCheck && updatedProperties) {
      this.requestUpdate();
      this.updateComplete.then((_) => this.validate());
    }
  }
  render() {
    return this.readonly ? this.renderReadonly() : this.renderComponent();
  }
  renderComponent() {
    var _a, _b, _c;
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="${this.inline ? "inline" : ""}">
        <div class="label-wrapper">
          <label for="isceco-text-input">
            ${this.label}
          </label>
          ${this.renderInfo()}
        </div>
        <input id="isceco-text-input"
               type="${this.type}"
               title="${(_a = this.title) != null ? _a : " "}"
               .value="${(_b = this.value) != null ? _b : ""}"
               maxlength="${this.maxlength}"
               placeholder="${this.placeholder}"
               pattern="${(_c = this.pattern) != null ? _c : ".*"}"
               ?disabled="${this.disabled}"
               ?required="${this.required}"
               @change="${(e) => this._change(e)}"
               @keyup="${(e) => this._keyup(e)}"
        />
      </div>
      <p id="message">
        <i class="exclamation triangle icon"></i>
        ${this.message}
      </p>
    `;
  }
  renderReadonly() {
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="${this.inline ? "readonly inline" : "readonly"}">
        <div class="label-wrapper">
          <span>${this.label}</span>
          ${this.renderInfo()}
        </div>
        <p>
          ${this._getReadOnlyValue()}
        </p>
      </div>
    `;
  }
  renderInfo() {
    if (isEmpty(this.helpText)) {
      return y``;
    } else {
      const helpText = this.helpText instanceof Function ? this.helpText() : this.helpText;
      return y`
        <isceco-popup direction="right">
          <i slot="wrapper" class="info circle icon"></i>
          <div slot="content">${helpText}</div>
        </isceco-popup>
      `;
    }
  }
  _getReadOnlyValue() {
    let value = "";
    if (!isEmpty(this.value)) {
      value = this.value;
    } else if (!isEmpty(this.placeholderEmpty)) {
      value = this.placeholderEmpty;
    }
    if (this.type === "date" && !isEmpty(this.value)) {
      value = formatDate(this.value);
    }
    return value;
  }
  _change(event) {
    event.preventDefault();
    event.stopPropagation();
    this.value = event.target.value;
    this.valueChanged = true;
    const valid = this.validate();
    send("change", { valid, value: this.value }, this);
  }
  _keyup(event) {
    event.stopPropagation();
    event.preventDefault();
    if (["Tab", "Shift"].includes(event.key)) {
      return;
    }
    this.value = event.target.value;
    const valid = this.validate();
    send("keyup", { valid, value: this.value }, this);
  }
  _translations() {
    return {
      de: {
        empty: "Wert darf nicht leer gelassen werden.",
        length: (l) => `Wert darf nicht l\xE4nger sein als ${l} Zeichen.`
      },
      fr: {
        empty: "La valeur ne doit pas \xEAtre laiss\xE9e vide.",
        length: (l) => `La valeur ne doit pas d\xE9passer ${l} caract\xE8res.`
      },
      it: {
        empty: "Il valore non deve essere lasciato vuoto.",
        length: (l) => `Il valore non pu\xF2 superare i ${l} caratteri.`
      },
      en: {
        empty: "Value must not be left empty.",
        length: (l) => `Value cannot be longer than ${l} characters.`
      }
    };
  }
}
customElements.define("isceco-text-input", TextInput);
export { TextInput as default };
